import { useViewAs } from "hooks/useViewAs";

import type { Crumb } from "./SecureExchangeBreadcrumbs";

/** Links between the Secure Exchange pages, inside Client View when it is on. */
export function useSecureExchangePaths() {
  const { href, profile } = useViewAs();
  const clientUser = profile?.user_type === "client";
  const client = (clientId: number) =>
    href(`/secure-exchange/clients/${clientId}`);
  const project = (clientId: number, projectId: number) =>
    href(`/secure-exchange/clients/${clientId}/projects/${projectId}`);
  const collection = (
    clientId: number,
    projectId: number,
    collectionId: number,
  ) =>
    href(
      `/secure-exchange/clients/${clientId}/projects/${projectId}/collections/${collectionId}`,
    );
  /** "Secure Exchange": the Client List for staff; a client user, who has no list,
   * is taken to their own client page by it, so it is no way back from there. */
  const home: Crumb = {
    label: "Secure Exchange",
    to: href("/secure-exchange"),
    back: !clientUser,
  };
  return { client, project, collection, home };
}
